export default "__VITE_PUBLIC_ASSET__571535ba__"